import isFunction from './isFunction';
import isStyledComponent from './isStyledComponent';
export default function isStaticRules(rules) {
    for (var i = 0; i < rules.length; i += 1) {
        var rule = rules[i];
        if (isFunction(rule) && !isStyledComponent(rule)) {
            // functions are allowed to be static if they're just being
            // used to get the classname of a nested styled component
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=isStaticRules.js.map